import React from 'react';

import { Colors } from 'modules/ui/theme/colors';
import { BadgeContainer, BadgeLabel } from './styledComponents';

type Props = {
  label: string;
  color?: string;
  labelColor?: string;
};

const Badge: React.FC<Props> = ({
  label,
  color = Colors.Secondary,
  labelColor = Colors.White,
}) => (
  <BadgeContainer color={color}>
    <BadgeLabel labelColor={labelColor}>{label}</BadgeLabel>
  </BadgeContainer>
);

export default React.memo(Badge);
